<template>
  <div id="interessados-divisoria">
    <div class="form-group row">
      <div class="col-sm-2 text-sm-right">
        <label>Destinatario: </label>
      </div>
      <div class="col-sm-9 mb-3">
        <div class="input-group">
          <select class="form-control center-select" v-model="active">
            <option v-for="(item, indice) in select.tipoInteressados" :key="indice" :value="item.tipoInteressado">
              {{ item.tipoInteressado }}
            </option>
          </select>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" @click=" () => {
              reniciarAlert()
              $refs.interessados.openModal()
            }">NOVO DESTINATÁRIO</button>
          </div>
        </div>
      </div>
    </div>
    <component
      :key="activeKey"
      v-bind:is="active"
      :progressName="active"
      :eventBusDataName="`${table.list.eventBusDataName}-${active}`"
      :eventBusPaginationName="`${table.list.eventBusPaginationName}-${active}`"
    ></component>

    <div class="container-md">
      <hr class="bg-muted">
      <div class="container mt-1">
        <alert-comp :key="alert.key" :msg="alert"/>
      </div>
      <h5>Destinatários - {{ active }}</h5>
      <data-table-consulta-comp class="mt-3"
                                :key="active"
                                :paginationKey="active"
                                :colNames="table.list.colNames[active]"
                                :eventBusDataName="`${table.list.eventBusDataName}-${active}`"
                                :eventBusDataPaginationName="`${table.list.eventBusPaginationName}-${active}`"
                                :dataTableColumn="table.list.dataTableColumn[active]">
        <template v-slot:default="slotProps">
          <td style="text-align: center; width: 100px !important;">
            <i class="fa fa-plus fa-1-5x link" aria-hidden="true" v-on:click="adicionar(slotProps.itemData)"></i>
          </td>
        </template>
      </data-table-consulta-comp>
    </div>

    <modal ref="interessados"  width="1000px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Interessados - Novo Contato</h4>
          <i class="fa fa-times fa-1-5x" @click="fecharModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body" id="interessados-divisoria">
          <manterContatoExterno :backButtonIsVisible="false" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import alertComp from '@/components/alert/AlertComp'
import modal from '@/components/shared/Modal'

import DestinatarioService from '@/services/DestinatarioService'

import { mapState } from 'vuex'
import { toContantoExterno } from '@/uteis/converters/ProtocoloConverter'

import manterContatoExterno from '@/components/manter-processo/contatoExterno/manter/ManterContatoExterno'
import filtroPessoaFisica from '@/components/filtro-interessados/filtros/FiltroPessoaFisica'
import filtroPessoaJuridica from '@/components/filtro-interessados/filtros/FiltroPessoaJuridica'
import filtroPoderExecutivo from '@/components/filtro-interessados/filtro-tramite/FiltroPoderExecutivo'
import filtroServidor from '@/components/filtro-interessados/filtros/FiltroServidor'

import { componentIsVisible, rules } from '@/uteis/action/permissao'

export default {
  components: {
    dataTableConsultaComp,
    alertComp,
    modal,
    'Pessoa Fisica': filtroPessoaFisica,
    'Pessoa Juridica': filtroPessoaJuridica,
    Servidor: filtroServidor,
    'Poder Executivo Estadual': filtroPoderExecutivo,
    manterContatoExterno
  },

  props: {
    eventBusDataName: { required: true, type: String },
    dataTableColumn: { required: true, type: Array },
    textError: { required: true, type: String }
  },

  data () {
    return {
      active: 'Poder Executivo Estadual',
      activeKey: true,
      alert: {
        type: '',
        texto: '',
        key: true
      },
      table: {
        list: {
          colNames: {
            'Pessoa Fisica': ['Tipo', 'Nome', 'CPF', 'Email', 'Ações'],
            'Pessoa Juridica': ['Tipo', 'Nome', 'CNPJ / IE', 'Email', 'Ações'],
            Servidor: ['Tipo', 'Nome', 'Matricula', 'Ações'],
            'Poder Executivo Estadual': [
              'Tipo',
              'Nome Departamento',
              'Sigla Departamento',
              'Nome Gestor', 'Cidade',
              'Ações']
          },
          dataTableColumn: {
            'Pessoa Fisica': [{
              column: 'tipoContatoExterno',
              converter: 'tipoContatoExterno'
            }, 'nome', 'identificador', 'email'],
            'Pessoa Juridica': [{
              column: 'tipoContatoExterno',
              converter: 'tipoContatoExterno'
            }, 'nome', 'identificador', 'email'],
            Servidor: [{ column: 'tipoContatoExterno', converter: 'tipoContatoExterno' }, 'nome', 'identificador'],
            'Poder Executivo Estadual': [
              {
                column: 'tipoContatoExterno',
                converter: 'tipoContatoExterno'
              },
              'nomeEstrutura',
              'siglaEstrutura',
              'nomeUsuario',
              'cidadeEstado'
            ]
          },
          eventBusDataName: 'listaInteressado',
          eventBusPaginationName: 'listaInteressadoPagination',
          rowsNumber: 6
        },
        selected: {
          dataTableColumn: {
            'Poder Executivo Estadual': ['siglaDepartamentoRemetente', 'siglaDepartamentoDestinatario', 'tipoDestinatario'],
            'Pessoa Fisica': ['siglaDepartamentoRemetente', 'nome', 'tipoDestinatario'],
            Servidor: ['siglaDepartamentoRemetente', 'nome', 'tipoDestinatario'],
            'Pessoa Juridica': ['siglaDepartamentoRemetente', 'nome', 'tipoDestinatario']
          },
          rowsNumber: 6
        }
      },
      select: {
        tipoInteressados: [
          { id: 1, tipoInteressado: 'Pessoa Fisica', situacao: 'ATIVO' },
          { id: 2, tipoInteressado: 'Pessoa Juridica', situacao: 'ATIVO' },
          { id: 3, tipoInteressado: 'Servidor', situacao: 'ATIVO' },
          { id: 4, tipoInteressado: 'Poder Executivo Estadual', situacao: 'ATIVO' }
        ]
      }
    }
  },

  created () {
    this.service = new DestinatarioService()

    const { DISTRIBUIR_PROTOCOLO } = rules
    if (componentIsVisible(DISTRIBUIR_PROTOCOLO)) {
      this.select.tipoInteressados = [
        { id: 4, tipoInteressado: 'Poder Executivo Estadual', situacao: 'ATIVO' }
      ]
    }
  },

  computed: {
    ...mapState({
      interessados: (state) => state.interessadosSelecionados
    })
  },

  watch: {
    interessados: function (newValue, oldValue) {
      if (this.interessados.length !== 0) {
        setTimeout(this.trocaDePagina, 200)
      }
    }
  },

  destroyed () {
    eventBus.$off(this.table.list.eventBusPaginationName)
  },

  methods: {
    interessadoIsSelected (interessado) {
      if (interessado && interessado.identificador) {
        const item = this.$store.state.interessadosSelecionados.filter(item => item.identificador === interessado.identificador)
        return item.length !== 0
      }

      if (interessado && interessado.email) {
        const item = this.$store.state.interessadosSelecionados.filter(item => item.email === interessado.email)
        return item.length !== 0
      }

      if (interessado && interessado.nome) {
        const item = this.$store.state.interessadosSelecionados.filter(item => item.nome.toLowerCase() === interessado.nome.toLowerCase())
        return item.length !== 0
      }

      return true
    },

    dtoEndereco (endereco) {
      if (!endereco) {
        return
      }
      const rua = !endereco.rua || endereco.rua === '' ? '' : `${endereco.rua}`
      var numero = ''
      if (rua === '') {
        numero = !endereco.numero || endereco.numero === '' ? 's/n ' : `${endereco.numero}`
      } else {
        numero = !endereco.numero || endereco.numero === '' ? ', s/n' : `, ${endereco.numero}`
      }
      const bairro = !endereco.bairro || endereco.bairro === '' ? '' : `, ${endereco.bairro}`
      const cep = !endereco.cep || endereco.cep === '' ? '' : `, CEP ${endereco.cep.replace(/(\d{5})(\d{3})/, '$1-$2')}`
      // const estado = !endereco.estado || endereco.estado === '' ? '' : `${endereco.estado}`
      // const cidade = !endereco.cidade || endereco.cidade === '' ? '' : estado ? `, ${endereco.cidade} - ` : endereco.cidade
      const complemento = !endereco.complemento || endereco.complemento === '' ? '' : `, ${endereco.complemento}`
      const formatado = `${rua}${numero}${bairro}${cep}${complemento}`

      return {
        ...endereco,
        descricao: formatado
      }
    },

    toInteressado (obj) {
      var dadosSessao = this.$store.getters.getDadosSessao
      var selecionado = obj
      var hasEndereco = false

      if (obj.tipoContatoExterno !== 'Poder Executivo Estadual') {
        hasEndereco = true
        if (selecionado.complemento) {
          selecionado.endereco.complemento = selecionado.complemento
        }
        var sessao = dadosSessao.sessao
        const endereco = this.dtoEndereco(selecionado.endereco)
        const interessado = {
          idDepartamentoRemetente: sessao.idDepartamento,
          idOrgaoRemetente: sessao.idOrgao,
          siglaDepartamentoRemetente: sessao.siglaDepartamento,
          descricaoDepartamentoRemetente: sessao.descricaoDepartamento,
          siglaOrgaoRemetente: sessao.siglaOrgao,
          descricaoOrgaoRemetente: sessao.descricaoOrgao,
          tipoDestinatario: toContantoExterno(selecionado.tipoContatoExterno).value,
          nome: selecionado.nome,
          cpfCnpj: selecionado.identificador,
          endereco: endereco,
          hasEndereco: hasEndereco
        }

        if (endereco) {
          const cidade = []
          if (endereco.cidade) {
            for (const value of endereco.cidade.toLowerCase().split(' ')) {
              cidade.push(value.charAt(0).toUpperCase() + value.slice(1))
            }
          }
          interessado.cidadeDestinatario = cidade.join(' ')
          interessado.estadoDestinatario = endereco.estado
        }

        return interessado
      }

      return {
        idDepartamentoDestinatario: selecionado.estruturaID,
        idOrgaoDestinatario: this.$store.state.filtroDestinatario.estruturaID,
        idDepartamentoRemetente: dadosSessao.sessao.idDepartamento,
        idOrgaoRemetente: dadosSessao.sessao.idOrgao,
        siglaDepartamentoDestinatario: selecionado.siglaEstrutura,
        descricaoDepartamentoDestinatario: selecionado.nomeEstrutura,
        siglaOrgaoDestinatario: this.$store.state.filtroDestinatario.siglaEstrutura,
        descricaoOrgaoDestinatario: this.$store.state.filtroDestinatario.nomeEstrutura,
        siglaDepartamentoRemetente: dadosSessao.sessao.siglaDepartamento,
        descricaoDepartamentoRemetente: dadosSessao.sessao.descricaoDepartamento,
        siglaOrgaoRemetente: dadosSessao.sessao.siglaOrgao,
        descricaoOrgaoRemetente: dadosSessao.sessao.descricaoOrgao,
        tipoDestinatario: toContantoExterno(selecionado.tipoContatoExterno).value,
        cidadeDestinatario: selecionado.cidade,
        estadoDestinatario: selecionado.estado,
        telefoneDestinatario: selecionado.telefone,
        logradouroDestinatario: selecionado.logradouro,
        bairroDestinatario: selecionado.bairro,
        cepDestinatario: selecionado.cep,
        numeroDestinatario: selecionado.numero,
        complementoDestinatario: selecionado.complemento,
        hasEndereco: hasEndereco
      }
    },

    adicionar (obj) {
      const interessado = this.toInteressado(obj)
      const motivosProcessos = this.$store.state.motivosProcessos

      for (const index in motivosProcessos) {
        const motivoProcesso = motivosProcessos[index]
        if (motivoProcesso.data.id === -1) {
          eventBus.$emit(this.eventBusDataName, {
            text: 'É preciso selecionar os motivos dos respectivos protocolos. Por gentileza, escolha um motivo para poder continuar.'
          })
          return
        }
      }

      var tramites = []

      for (const index in motivosProcessos) {
        const motivoProcesso = motivosProcessos[index]
        tramites.push({
          processo: motivoProcesso.itemData.processo,
          motivo: motivoProcesso.data.id
        })
      }

      var destinatarios = {
        destinatario: interessado,
        tramites
      }

      // var numeroPagina = 1
      // var rowsNumber = 10

      this.service.salvarDestinatario(destinatarios).then((response) => {
        if (response) {
          // var dataValues = new DataValues(response.data, numeroPagina, rowsNumber)
          // dataValues.dataTableColumn = this.table.selected.dataTableColumn[this.active]

          eventBus.$emit(this.eventBusDataName)
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    reniciarAlert () {
      this.alert = { type: '', texto: '', key: !this.alert.key }
    },

    fecharModal () {
      this.activeKey = !this.activeKey
      this.$refs.interessados.closeModal()
    }
  }
}
</script>
